import { forwardRef } from 'react'
import './Input.css'

const Input = forwardRef(({
  label,
  error,
  helperText,
  fullWidth = false,
  className = '',
  id,
  ...props
}, ref) => {
  const inputId = id || `input-${Math.random().toString(36).substr(2, 9)}`
  const classes = [
    'input-wrapper',
    fullWidth && 'input-full-width',
    error && 'input-error',
    className,
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <div className={classes}>
      {label && (
        <label htmlFor={inputId} className="input-label">
          {label}
        </label>
      )}
      <input
        id={inputId}
        ref={ref}
        className="input"
        {...props}
      />
      {error && <span className="input-error-text">{error}</span>}
      {helperText && !error && (
        <span className="input-helper-text">{helperText}</span>
      )}
    </div>
  )
})

Input.displayName = 'Input'

export default Input

